import{ClarityMotion as r,AnimationModalEnterName as e,AnimationModalEnterConfig as o,registerElementSafely as a}from"@cds/core/internal";import{CdsInternalOverlay as l}from"./overlay.element.js";r.add(e,o),a("cds-internal-overlay",l);
